import { Box, Stack, Typography, IconButton, Chip } from "@mui/material";
import { Close } from "@mui/icons-material";
import { helper } from "../../../../utils/helper.js";

function getInitials(libelle) {
    if (!libelle) return "?";
    const parts = libelle.trim().split(/\s+/);
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

function getTempsTravail(workMinutes) {
    const total = workMinutes || 0;
    const h = Math.floor(total / 60);
    const m = total % 60;
    return `${h}h${m > 0 ? String(m).padStart(2, "0") + "m" : ""}`;
}

export default function EquipageDetailHeader({ data, onClose, pendingAlertCount }) {
    const libelle = data?.operateur?.libelle || "";
    const initials = getInitials(libelle);
    const fdtId = data?.feuilleDeTemps?.id;
    const validatedAt = data?.feuilleDeTemps?.validatedAt;
    const workMinutes = data?.feuilleDeTemps?.workMinutes;

    let dateLabel = "";
    try {
        if (data?.date) {
            const d = new Date(data.date);
            dateLabel = d.toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
        }
    } catch (_) {}

    return (
        <Box sx={{ background: "#1e293b", padding: "18px 24px", display: "flex", alignItems: "center", gap: "14px" }}>
            {/* Avatar */}
            <Box sx={{
                width: 40, height: 40, borderRadius: "50%", background: "#334155",
                display: "flex", alignItems: "center", justifyContent: "center",
                fontWeight: 700, fontSize: "14px", color: "white", flexShrink: 0,
            }}>
                {initials}
            </Box>

            {/* Infos opérateur */}
            <Box sx={{ flex: 1 }}>
                <Stack direction="row" alignItems="center" gap={1}>
                    <Typography sx={{ fontWeight: 700, fontSize: "16px", color: "white" }}>
                        {libelle}
                    </Typography>
                    {fdtId && (
                        <Box sx={{ background: "#475569", color: "#cbd5e1", fontSize: "10px", padding: "2px 7px", borderRadius: "4px" }}>
                            Feuille de temps #{fdtId}
                        </Box>
                    )}
                </Stack>
                <Typography sx={{ color: "#94a3b8", fontSize: "11px", mt: "2px" }}>
                    {dateLabel}{data?.client ? ` · ${data.client}` : ""}
                </Typography>
            </Box>

            {/* Droite : alertes + temps + statut + fermer */}
            <Stack direction="row" alignItems="center" gap="10px">
                {pendingAlertCount > 0 && (
                    <Box sx={{
                        background: "#ef4444", color: "white", borderRadius: "50%",
                        width: 24, height: 24, display: "flex", alignItems: "center",
                        justifyContent: "center", fontWeight: 700, fontSize: "11px",
                        animation: "pulse 1.5s infinite",
                        "@keyframes pulse": {
                            "0%": { boxShadow: "0 0 0 0 rgba(239,68,68,0.5)" },
                            "70%": { boxShadow: "0 0 0 8px rgba(239,68,68,0)" },
                            "100%": { boxShadow: "0 0 0 0 rgba(239,68,68,0)" },
                        },
                    }}>
                        {pendingAlertCount}
                    </Box>
                )}

                <Box sx={{ textAlign: "right" }}>
                    <Typography sx={{ fontSize: "19px", fontWeight: 700, color: "white", lineHeight: 1 }}>
                        {getTempsTravail(workMinutes)}
                    </Typography>
                    <Typography sx={{ color: "#94a3b8", fontSize: "10px" }}>Temps calculé</Typography>
                </Box>

                {validatedAt ? (
                    <Chip
                        label={`✓ Validée le ${helper.getFormattedDatetime(validatedAt)}`}
                        size="small"
                        sx={{ background: "#16a34a", color: "white", fontWeight: 600, fontSize: "10px" }}
                    />
                ) : (
                    <Chip
                        label="Non validée"
                        size="small"
                        sx={{ background: "#475569", color: "#cbd5e1", fontSize: "10px" }}
                    />
                )}

                <IconButton onClick={onClose} size="small" sx={{ color: "#94a3b8", "&:hover": { color: "white" } }}>
                    <Close fontSize="small" />
                </IconButton>
            </Stack>
        </Box>
    );
}
